import classify from '../helpers/classify';

function initListerIntro(listerIntroElm: HTMLDivElement): void {
  if (!listerIntroElm) {
    return;
  }

  const buttonExpand = listerIntroElm.querySelector<HTMLButtonElement>(classify('cms-lister-intro__expand'));
  const buttonCollapse = listerIntroElm.querySelector<HTMLButtonElement>(classify('cms-lister-intro__collapse'));
  const descriptionContainer = listerIntroElm.querySelector<HTMLButtonElement>(
    classify('cms-lister-intro__description')
  );

  if (!buttonExpand || !buttonCollapse || !descriptionContainer) {
    return;
  }

  const defaultHeight = descriptionContainer.scrollHeight;
  let lastHeight = 0;

  buttonExpand.addEventListener('click', (): void => {
    descriptionContainer.classList.toggle('active');
    buttonExpand.hidden = true;

    const currentHeight = descriptionContainer.scrollHeight;
    lastHeight = currentHeight;
    descriptionContainer.style.height = `${defaultHeight}px`;
    setTimeout(() => {
      descriptionContainer.style.height = `${currentHeight}px`;
    }, 0);
  });

  buttonCollapse.addEventListener('click', () => {
    descriptionContainer.style.height = `${lastHeight}px`;
    setTimeout(() => {
      descriptionContainer.style.height = `${defaultHeight}px`;
      buttonExpand.hidden = false;
      descriptionContainer.classList.toggle('active');
    }, 0);
  });

  descriptionContainer.addEventListener('transitionend', (e) => {
    const target = <HTMLElement>e.target;

    if (target !== descriptionContainer) {
      return;
    }

    descriptionContainer.removeAttribute('style');
  });
}

export default function initAllListerIntro(): void {
  const showMoreComponents = document.querySelectorAll<HTMLDivElement>(classify('cms-lister-intro'));
  showMoreComponents.forEach(initListerIntro);
}
